import { render, staticRenderFns } from "./RemoteConnectionList.vue?vue&type=template&id=84e528de"
import script from "./RemoteConnectionList.vue?vue&type=script&lang=js"
export * from "./RemoteConnectionList.vue?vue&type=script&lang=js"
import style0 from "./RemoteConnectionList.vue?vue&type=style&index=0&id=84e528de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports